module.exports = __webpack_public_path__ + "271db93022e3f8a079b4f3f727f2e3e9.mp3";